import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { d as x, p as P, r as h, U as v } from "../../vendor-CPVnY93G.js";
import { Fragment as O } from "react";
import { getSpacingClasses as T } from "../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as j } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as F } from "../BaseIcon/index.js";
import { TooltipTrigger as S, Tooltip as z } from "../Tooltip/index.js";
import '../../assets/index34.css';const B = "_pill_1y2b4_1", C = "_iconOnly_1y2b4_25", E = "_moon_1y2b4_31", I = "_teal_1y2b4_41", N = "_green_1y2b4_51", R = "_cactus_1y2b4_61", U = "_gold_1y2b4_71", W = "_sienna_1y2b4_81", k = "_red_1y2b4_91", q = "_magenta_1y2b4_101", w = "_purple_1y2b4_111", A = "_blue_1y2b4_121", c = {
  pill: B,
  iconOnly: C,
  moon: E,
  teal: I,
  green: N,
  cactus: R,
  gold: U,
  sienna: W,
  red: k,
  magenta: q,
  purple: w,
  blue: A
};
function Q({
  textValue: n,
  tooltip: t,
  icon: r,
  color: a = "teal",
  m: i,
  mt: _,
  mr: p,
  ml: m,
  mb: b,
  ...s
}) {
  const d = x(
    c[a],
    c.pill,
    !n && c.iconOnly,
    T({ m: i, mb: b, ml: m, mr: p, mt: _ })
  ), { focusProps: f, isFocusVisible: y } = P(s), o = t?.children, g = o ? v : O, u = o ? "button" : "span", $ = o ? h(s, f, {
    "aria-disabled": !0,
    "data-focus-visible": y || void 0
  }) : s;
  return /* @__PURE__ */ l(S, { children: [
    /* @__PURE__ */ e(g, { children: /* @__PURE__ */ l(u, { ...j($), className: d, "data-component": "Pill", children: [
      r && /* @__PURE__ */ e(F, { color: a, icon: r, size: "xs", mr: n ? 2 : 0 }),
      n
    ] }) }),
    o && /* @__PURE__ */ e(z, { ...t })
  ] });
}
export {
  Q as Pill
};
